import React, {Fragment} from 'react';
import {convertStoMs} from "../functions/convertStoMs";
import useAuth from "../hooks/useAuth";
import {isAuthenticated} from "../functions/isAuthenticated";


function AuthStats() {

  const {auth} = useAuth();
  return (
    <Fragment>
      {
        process.env.NODE_ENV === 'development' ?

          <Fragment>
            {isAuthenticated(auth) &&
            <div className="border rounded p-4 mb-0 w-100 d-flex small">
              <div className="" style={{overflowWrap: 'anywhere'}}>

                <h4>Nerd stuff for Mick</h4>
                {auth.email && <p className="text-primary">{JSON.stringify(auth, null, 2)}</p>}
                {auth.exp && <p className="text-info">Session
                  Expires: {(new Date(auth.exp * 1000)).toLocaleTimeString()} ({convertStoMs(((auth.exp - (Date.now() / 1000))))})</p>}
                <b>Hi {auth?.email ? auth?.email : 'Guest '}, you are {!auth?.email && 'NOT '}logged in!</b>
                <br/>

              </div>
            </div>
            }
          </Fragment>

          : null
      }

    </Fragment>
  );
}

export default AuthStats;
